import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/channelPartnerWebhooks/useChannelPartnerWebhookQueryKeys.ts
var t = e("channel-partner-webhooks", {
	deliveries: (e) => e === void 0 ? ["deliveries"] : ["deliveries", e],
	deliveryStats: (e) => e === void 0 ? ["delivery-stats"] : ["delivery-stats", e],
	endpoint: (e, t) => e === void 0 ? ["endpoint"] : [
		"endpoint",
		e,
		t
	]
});
//#endregion
export { t as channelPartnerWebhookQueryKeys };
